import chualang from "../images/chualang.png";
import kinhte from "../images/kinhte.png";
import vanquan from "../images/vanquan.png";
import namdong from "../images/namdong.png";
import nongnghiep from "../images/nongnghiep.png";
import taichinh from "../images/taichinh.png";
import caugiay from "../images/caugiay.png";

export const times = [
    {
        label: "09:00",
        value: "09:00",
        key: 9
    },
    {
        label: "09:15",
        value: "09:15",
        key: 9.25
    },
    {
        label: "09:30",
        value: "09:30",
        key: 9.5
    },
    {
        label: "09:45",
        value: "09:45",
        key: 9.75
    },
    {
        label: "10:00",
        value: "10:00",
        key: 10
    },
    {
        label: "10:15",
        value: "10:15",
        key: 10.25
    },
    {
        label: "10:30",
        value: "10:30",
        key: 10.5
    },
    {
        label: "10:45",
        value: "10:45",
        key: 10.75
    },
    {
        label: "11:00",
        value: "11:00",
        key: 11
    },
    {
        label: "11:15",
        value: "11:15",
        key: 11.25
    },
    {
        label: "11:30",
        value: "11:30",
        key: 11.5
    },
    {
        label: "11:45",
        value: "11:45",
        key: 11.75
    },
    {
        label: "12:00",
        value: "12:00",
        key: 12,
    },
    {
        label: "12:15",
        value: "12:15",
        key: 12.25
    },
    {
        label: "12:30",
        value: "12:30",
        key: 12.5,
    },
    {
        label: "12:45",
        value: "12:45",
        key: 12.75
    },
    {
        label: "13:00",
        value: "13:00",
        key: 13
    },
    {
        label: "13:15",
        value: "13:15",
        key: 13.25
    },
    {
        label: "13:30",
        value: "13:30",
        key: 13.5
    },
    {
        label: "13:45",
        value: "13:45",
        key: 13.75
    },
    {
        label: "14:00",
        value: "14:00",
        key: 14
    },
    {
        label: "14:15",
        value: "14:15",
        key: 14.25
    },
    {
        label: "14:30",
        value: "14:30",
        key: 14.5
    },
    {
        label: "14:45",
        value: "14:45",
        key: 14.75
    },
    {
        label: "15:00",
        value: "15:00",
        key: 15
    },
    {
        label: "15:15",
        value: "15:15",
        key: 15.25
    },
    {
        label: "15:30",
        value: "15:30",
        key: 15.5
    },
    {
        label: "15:45",
        value: "15:45",
        key: 15.75
    },
    {
        label: "16:00",
        value: "16:00",
        key: 16
    },
    {
        label: "16:15",
        value: "16:15",
        key: 16.25
    },
    {
        label: "16:30",
        value: "16:30",
        key: 16.5
    },
    {
        label: "16:45",
        value: "16:45",
        key: 16.75
    },
    {
        label: "17:00",
        value: "17:00",
        key: 17,
    },
    {
        label: "17:15",
        value: "17:15",
        key: 17.25
    },
    {
        label: "17:30",
        value: "17:30",
        key: 17.5
    },
    {
        label: "17:45",
        value: "17:45",
        key: 17.75
    },
    {
        label: "18:00",
        value: "18:00",
        key: 18,
    },
    {
        label: "18:15",
        value: "18:15",
        key: 18.25
    },
    {
        label: "18:30",
        value: "18:30",
        key: 18.5
    },
    {
        label: "18:45",
        value: "18:45",
        key: 18.75
    },
    {
        label: "19:00",
        value: "19:00",
        key: 19
    },
    {
        label: "19:15",
        value: "19:15",
        key: 19.25
    },
    {
        label: "19:30",
        value: "19:30",
        key: 19.5
    },
    {
        label: "19:45",
        value: "19:45",
        key: 19.75
    },
    {
        label: "20:00",
        value: "20:00",
        key: 20
    },
    {
        label: "20:15",
        value: "20:15",
        key: 20.25
    },
    {
        label: "20:30",
        value: "20:30",
        key: 20.5
    },
    {
        label: "20:45",
        value: "20:45",
        key: 20.75
    },
    {
        label: "21:00",
        value: "21:00",
        key: 21
    },
    {
        label: "21:15",
        value: "21:15",
        key: 21.25
    },
    {
        label: "21:30",
        value: "21:30",
        key: 21.5
    },
    {
        label: "21:45",
        value: "21:45",
        key: 21.75
    },
    {
        label: "22:00",
        value: "22:00",
        key: 22
    },
    {
        label: "22:15",
        value: "22:15",
        key: 22.25
    },
    {
        label: "22:30",
        value: "22:30",
        key: 22.5
    },
    {
        label: "22:45",
        value: "22:45",
        key: 22.75
    },
    {
        label: "23:00",
        value: "23:00",
        key: 23
    },
    {
        label: "23:15",
        value: "23:15",
        key: 23.25
    },
    {
        label: "23:30",
        value: "23:30",
        key: 23.5
    },
    {
        label: "23:45",
        value: "23:45",
        key: 23.75
    },
    {
        label: "00:00",
        value: "00:00",
        key: 24
    },
    {
        label: "00:15",
        value: "00:15",
        key: 24.25
    },
    {
        label: "00:30",
        value: "00:30",
        key: 24.5
    },
    {
        label: "00:45",
        value: "00:45",
        key: 24.75
    },
    {
        label: "01:00",
        value: "01:00",
        key: 25,
    },
    {
        label: "01:15",
        value: "01:15",
        key: 25.25
    },
    {
        label: "01:30",
        value: "01:30",
        key: 25.5
    },
    {
        label: "01:45",
        value: "01:45",
        key: 25.75
    },
    {
        label: "02:00",
        value: "02:00",
        key: 26
    },
    {
        label: "02:15",
        value: "02:15",
        key: 26.25
    },
    {
        label: "02:30",
        value: "02:30",
        key: 26.5
    },
    {
        label: "02:45",
        value: "02:45",
        key: 26.75
    }
];

export const minutes = [
    {
        label: "30 phút",
        value: "30",
    },
    {
        label: "60 phút",
        value: "60",
    },
    {
        label: "45 phút",
        value: "45",
    },
    {
        label: "90 phút",
        value: "90",
    },
    {
        label: "105 phút",
        value: "105",
    },
    {
        label: "120 phút",
        value: "120",
    },
    {
        label: "135 phút",
        value: "135",
    },
    {
        label: "150 phút",
        value: "150",
    },
    {
        label: "165 phút",
        value: "165",
    },
    {
        label: "180 phút",
        value: "180",
    },
    {
        label: "210 phút",
        value: "210",
    },
    {
        label: "240 phút",
        value: "240",
    },
    {
        label: "270 phút",
        value: "270",
    },
    {
        label: "300 phút",
        value: "300",
    },
];

export const rooms = [
    {
        value: 1,
        label: "S Box (1-2 người)",
        time: "Trước 18h: 60.000VND/h",
    },
    {
        value: 2,
        label: "M Box (3-7 người)",
        time: "Trước 18h: 60.000VND/h",
    },
    {
        value: 3,
        label: "S Box (1-2 người)",
        time: "Sau 18h: 90.000VND/h",
    },
    {
        value: 4,
        label: "L Box (trên 5 người)",
        time: "Sau 18h: 120.000VND/h",
    },
    {
        value: 4,
        label: "L Box (trên 5 người)",
        time: "Sau 18h: 120.000VND/h",
    },
];

export const restrictNumber = (event) => {
    const regex = new RegExp("^[0-9]+$");
    const key = String.fromCharCode(
        !event.charCode ? event.which : event.charCode,
    );
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
};

export const moneyFormat = (number) => {
    // Chuyển đổi số thành chuỗi và loại bỏ tất cả các ký tự không phải số
    const integerPart = `${parseInt(number, 10)}`;

    // Sử dụng regex để thêm dấu chấm ngăn cách các hàng đơn vị
    return integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

export const errorCode = {
    2000: "Thành công",
    1000: "Lỗi",
    1002: "Token không hợp lệ hoặc hết hạn, yêu cầu quay về trang đăng nhập",
    1004: "Tham số không hợp lệ",
    2101: "Không còn phòng, hiển thị danh sách gợi ý",
    2102: "Không còn phòng",
    1007: "Không còn phòng trống",
    10044: "Tham số các trường dữ liệu về thời gian không hợp lệ",
    1009: "Cần có tham số captcha",
    1010: "Sai captcha",
    1011: "Chưa gửi được mã PIN. Vui lòng thử lại sau",
    1012: "PIN không đúng",
    1013: "PIN đang bị khóa tạm thời. Vui lòng thử lại sau",
    1014: "Đơn đặt phòng đang được xử lý, vui lòng chờ trong giây lát",
};

export function formatDateISOString(date) {
    return new Date(
        date.valueOf() - new Date(date).getTimezoneOffset() * 60 * 1000,
    );
}

export const dataBanner = {
    title_one: "Giải phóng âu lo",
    title_two: "Tự do thể hiện",
    contents: [
        {
            id: 1,
            content:
                "Chuỗi phòng thu âm, giải trí hàng đầu tại Việt Nam theo phong cách Hàn Quốc",
        },
        {
            id: 2,
            content:
                "Mang lại niềm vui, dành cho mọi lứa tuổi chung đam mê ca hát và âm nhạc",
        },
    ],
};

export const dataShops = [
    {
        id: 1,
        name: "Cơ sở chùa láng",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: chualang,
    },
    {
        id: 2,
        name: "Cơ sở nam đồng",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: namdong,
    },
    {
        id: 3,
        name: "Cơ sở kinh tế",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: kinhte,
    },
    {
        id: 4,
        name: "Cơ sở cầu giấy",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: caugiay,
    },
    {
        id: 5,
        name: "Cơ sở tài chính",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: taichinh,
    },
    {
        id: 6,
        name: "Cơ sở nông nghiệp",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: nongnghiep,
        image: nongnghiep,
    },
    {
        id: 7,
        name: "Cơ sở nam đồng",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: namdong,
    },
    {
        id: 8,
        name: "Cơ sở văn quán",
        address: "Tầng 2, số 2 nhà 32 Nam Đồng",
        branchId: "",
        image: vanquan,
    },
];
